// ============= frontend/src/pages/BuyPhysicalBook.js
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

function BuyPhysicalBook() {
  const navigate = useNavigate();

  const paperback = 19.79;

  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const [input, setInput] = useState({
    qty_paperback: "1",
    name2: "",
    phone2: "",
    email2: "",
    description_paperback: "",

    street2: "",
    city2: "",
    state_province2: "",
    postal_ZIP_code2: "",
    country2: "",
  });

  const handleChange = (e) => {
    let newValue = {
      ...input,
      [e.target.name]: e.target.value,
    };
    setInput(newValue);
  };

  const [error2, setError2] = useState("");

  const CheckPaperBack = (e) => {
    e.preventDefault();
    setError2("");
    if (input.name2 && input.phone2 && input.email2 && input.street2 && input.city2 && input.state_province2 && input.postal_ZIP_code2 && input.country2) {
      try {
        navigate('/Buy_checkout_no_influencer',
          {
            state: {
              type: "PAPERBACK",
              qty: input.qty_paperback,
              amount: input.qty_paperback * paperback,
              name: input.name2,
              phone: input.phone2,
              email: input.email2,
              description: input.description_paperback,

              street: input.street2,
              city: input.city2,
              state_province: input.state_province2,
              postal_ZIP_code: input.postal_ZIP_code2,
              country: input.country2
            }
          });
      } catch (error2) {
        console.log(error2);
      }
    } else {
      setError2("Error: Missing information (Add shipping details below)");
    }
  }

  return (
    <div>
      <div className="book">
        <center>
          <div className=" slider_book_text1 h2 text-white">ORDER YOUR COPY TODAY</div>
        </center>
      </div>

      <div className="mt-3">
        <center>
          <img className="img_time" src={'/images/icons/clock/2.gif'} alt="" /><br />
          <div>
            <div className='time_text1'> LIMITED AVAILABILITY!</div>
            <div className='text_tax_buy'>Exclusive to JuniorPersist.com</div>
          </div>
        </center>
      </div>
      <div className="d-sm-none d-block mb-4"></div>

      <div className="buy_7585 ">
        <div className="container">
          <div className="row">

            {/*========================PAPERBACK=====================  */}
            <div className="col-sm-6 mb-2 m-auto">
              <div className="int_cont1_buy ">
                <center>
                  <img className="buy_image001" src='/images/new_images/3.png' alt="" />
                  <h3 className="py-4 text-white">PAPERBACK</h3>
                </center>

                <div className="bar_cont2_buy py-4">
                  <center>
                    <table className="buy_table">
                      <tbody>
                        <tr>
                          <td><span className="buy_text56">Price:</span> $ {Number(paperback).toFixed(2)}</td>
                          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                          <td><span className="buy_text56">Quantity: </span>
                            <div className="d-block d-sm-none"></div>
                            <input className="buy_input_98" name="qty_paperback" value={input.qty_paperback} type="number" onChange={handleChange} /></td>
                        </tr>
                      </tbody>
                    </table>
                  </center>
                </div>

                <div className="container px-4 pb-3">
                  <div className="cont_cent_buy_7468">
                    <div className="cont2_cent_buy_7468">
                      <table className="table_buy_345">
                        <tbody>
                          <tr>
                            <td>Subtotal:</td>
                            <td>$ {Number(input.qty_paperback * paperback).toFixed(2)}</td>
                          </tr>

                          <tr>
                            <td className="total_buy">Total:</td>
                            <td className="total_buy">$ {Number(input.qty_paperback * paperback).toFixed(2)} USD</td>
                          </tr>
                        </tbody>
                      </table>
                      <p className="text_tax_buy">Taxes and shipping calculated at checkout</p>
                      {error2 && <div className='error_text'>{error2}</div>}
                      <input className="input_part2_jett2" placeholder='Name' name="name2" type="text" id="name2" required onChange={handleChange} />
                      <input className="input_part2_jett2" placeholder='Phone' name="phone2" type="text" id="phone2" required onChange={handleChange} />
                      <input className="input_part2_jett2" placeholder='Email Address' name="email2" type="text" id="email2" required onChange={handleChange} />

                      <textarea className="input_part2_jett2" placeholder="Order note" name="description_paperback" onChange={handleChange}></textarea>

                      {/* ============ SHIPPING ============ */}
                      <div>
                        <input id="shipping99" className="form-check-input" type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
                        <label className="form-check-label" htmlFor="shipping99">
                          &nbsp; Shipping Address
                        </label>
                      </div>

                      {isChecked && (
                        <div>
                          <input className="input_part2_jett2" placeholder='Street Address' name="street2" type="text" id="street2" required onChange={handleChange} />
                          <input className="input_part2_jett2" placeholder='City' name="city2" type="text" id="city2" required onChange={handleChange} />
                          <input className="input_part2_jett2" placeholder='State/Province' name="state_province2" type="text" id="state_province2" required onChange={handleChange} />
                          <input className="input_part2_jett2" placeholder='Postal/ZIP Code' name="postal_ZIP_code2" type="text" id="postal_ZIP_code2" required onChange={handleChange} />
                          <select className="input_part2_jett2" name="country2" id="country2" required defaultValue="" onChange={handleChange}>
                            <option value="" disabled>Select your country</option>
                            <option value="USA">USA</option>
                          </select>
                        </div>
                      )}
                      {/* ============ /SHIPPING ============ */}

                      <div>
                        <center>
                          <div className="mt-2 mb-4">
                            <button onClick={(e) => { CheckPaperBack(e) }} className="btn_buy_now2"><i className="bi bi-lock px-2"></i>PROCEED TO SAFE CHECKOUT</button>
                          </div>
                        </center>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

        <div className="d-none d-sm-block"><br /></div>
      </div>
    </div>
  )
}

export default BuyPhysicalBook
